import { render, staticRenderFns } from "./UniversalNav.vue?vue&type=template&id=7919a1a6&scoped=true"
import script from "./UniversalNav.vue?vue&type=script&lang=js"
export * from "./UniversalNav.vue?vue&type=script&lang=js"
import style0 from "./UniversalNav.vue?vue&type=style&index=0&id=7919a1a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7919a1a6",
  null
  
)

export default component.exports